export const instrumentationSchema = {
  scenario: [
    {
      name: 'mobileAppInstallPrompt',
      value: 'MobileAppInstallPrompt',
      setting: {},
      activity: [
        {
          name: 'promptActivity',
          value: 'PromptActivity',
        },
      ],
    },
  ],
};
